import React from 'react';
import { useFavorites } from '../Hooks/useFavorites';
import { translate } from '../Services/translation';

const FavoriteButton = ({ item, productData, className = '', children }) => {
    const { isFavorite, toggleFavorite, loading } = useFavorites();

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(item, productData);
    };

    const isItemFavorite = isFavorite(item);
    const tooltipText = isItemFavorite
        ? translate('favorites.remove')
        : translate('favorites.add');

    return (
        <div className="favorite-button-container">
            <button
                type="button"
                onClick={handleClick}
                disabled={loading}
                className={`favorite-button ${isItemFavorite ? 'is-favorite' : ''} ${className}`}
                aria-label={tooltipText}
                title={tooltipText}
            >
                {children || (
                    <span className="favorite-icon">
                        <i className={`ph ph-bookmark-simple${isItemFavorite ? "-fill" : "-thin"}`}></i>
                    </span>
                )}
            </button>
        </div>
    );
};

export default FavoriteButton;
